<template>
  <div class="app-label d-inline-flex justify-content-between"
       :class="{'just-added': justAdded, 'just-edited': justEdited, 'just-removed': justRemoved}"
  >
    <div>
      <i v-if="['file', 'link'].includes(attachment.attachmentType)" :class="['type-icon', iconClass]"></i>
      <img v-else-if="attachment && attachment.iconUrl" :src="attachment.iconUrl" class="mar-r-2 max18px" />
      <span class="labels-body mx-1">
        <a target="_blank" :href="attachment.link">{{ name }}</a>
      </span>
    </div>
    <div>
      <template v-if="justRemoved">
        <app-icon-with-action @click="$emit('return', attachment.id)">
          <i class="fal fa-undo"></i>
        </app-icon-with-action>
      </template>
      <template v-else>
        <app-icon-with-action v-if="allowEdit" @click="openAttachmentsWindow">
          <i class="fal fa-pencil mx-1"></i>
        </app-icon-with-action>
        <app-icon-with-action v-if="deletable" @click="$emit('delete', attachment.id)">
          <i class="fal fa-times-circle"></i>
        </app-icon-with-action>
      </template>
    </div>
    <portal :to="portalNameForm" v-if="editable">
      <attachments-window
        :attachment="attachment"
        @attachment-updated="updateAttachments"
        @close="closeAttachmentsWindow"
        class="mt-1"
        v-if="isAttachmentWindowDisplayed"
      ></attachments-window>
    </portal>
  </div>
</template>

<script>
import AttachmentsWindow from '@/components/attachmentsNew/AttachmentsWindow'
import AppIconWithAction from '@/components/htmlHelpers/AppIconWithAction'
import BaseComponent from '@/components/commentsNew/BaseComponent'
export default {
  name: 'AttachmentLabel',
  extends: BaseComponent,
  components: { AppIconWithAction, AttachmentsWindow },
  props: {
    portalNameForm: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    attachment: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    justEdited: {
      type: Boolean,
      default: false
    },
    justRemoved: {
      type: Boolean,
      default: false
    },
    justAdded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isAttachmentWindowDisplayed: false
    }
  },
  computed: {
    allowEdit () {
      if (!['link', 'file'].includes(this.attachment.attachmentType)) {
        return false
      }
      return this.editable
    },
    name () {
      return this.attachment.attachmentName || this.attachment.fileDescription || this.attachment.fileName || this.attachment.attachmentLink || this.attachment.AttachmentName || this.attachment.FileDescription || this.attachment.FileName || this.attachment.AttachmentLink
    },
    iconClass () {
      let icon = ''
      const type = this.attachment.attachmentType || this.attachment.AttachmentType
      switch (type) {
        case 'link':
          icon = 'fal fa-link'
          break
        case 'file':
          icon = 'fal fa-paperclip'
          break
      }
      return icon
    }
  },
  methods: {
    openAttachmentsWindow () {
      this.isAttachmentWindowDisplayed = true
    },
    closeAttachmentsWindow () {
      this.isAttachmentWindowDisplayed = false
    },
    updateAttachments (data) {
      this.closeAttachmentsWindow()
      this.$emit('update', data)
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";
.app-label {
  background-color: $gray-200;
  border: 1px solid $gray-200;
  border-radius: 4px;
  padding: 2px 6px;
  color: $text-color-gray;
  &.just-added:not(.just-removed), .just-edited:not(.just-removed) {
    background-color: $white;
    border: 1px dotted black;
  }
  i, a {
    color: $text-color-gray;
  }
  .labels-body a {
    &:hover {
      color: $primary;
    }
  }
  &.just-removed {
    .labels-body a {
      color: $text-color-gray-disabled;
      &:hover {
        color: $primary;
      }
    }
    i.type-icon {
      color: $text-color-gray-disabled
    }
  }
}
.max18px {
  max-width: 18px;
  max-height: 18px;
}
</style>
